define("shared/modifiers/load-image-async", ["exports", "ember-modifier", "later/utils/constants"], function (_exports, _emberModifier, _constants) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-modifier",0,"later/utils/constants"eaimeta@70e063a35619d71f
  /**
   *  Modifier to load the src of an image asynchronously.
   *  Show a placeholder image while the image is loading.
   *
   */

  class LoadAsyncModifier extends _emberModifier.default {
    modify(element, _ref) {
      let [processingImageUrl, newSource, onError] = _ref;
      if (processingImageUrl) {
        const image = new Image();
        const source = newSource || element.src;
        element.src = processingImageUrl;
        image.onload = () => element.src = source;
        image.onerror = () => {
          element.src = _constants.EMPTY_IMAGE_URL;
          onError?.();
        };
        image.src = source;
      }
    }
  }
  _exports.default = LoadAsyncModifier;
});